// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"dropdownContainer-EWIF3","label":"label-rGw35"};